import { useState } from "react";
import { NAV_LINKS, ZONE_LINKS } from "../../../mocks/chigua";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40">
      {/* 顶栏细带：运营口径 */}
      <div className="bg-foreground-950 text-background-100">
        <div className="mx-auto max-w-7xl px-4 md:px-6 h-9 flex items-center justify-between text-[11px] md:text-xs">
          <div className="flex items-center gap-2 truncate">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-400 animate-cg-blink" />
            <span className="tracking-wide">吃瓜现场 · 滚动更新中</span>
            <span className="hidden sm:inline text-background-100/60">今晚 20:00 现场加更</span>
          </div>
          <div className="flex items-center gap-3 text-background-100/70 whitespace-nowrap">
            <span className="hidden md:inline">人物打码 · 剧情虚构 · 理性吃瓜</span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-user-heart-line" />
              围观群众 360万+
            </span>
          </div>
        </div>
      </div>

      {/* 主站头 */}
      <div className="border-b border-foreground-950/10 bg-background-50/95 backdrop-blur">
        <div className="mx-auto max-w-7xl px-4 md:px-6 h-16 md:h-[76px] flex items-center justify-between gap-4">
          <a href="#hero" className="flex items-center gap-3 shrink-0">
            <span className="relative grid place-items-center h-10 w-10 rounded-sm bg-primary-600 text-background-50">
              <i className="ri-eye-2-line text-xl" />
              <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-accent-500 animate-cg-blink" />
            </span>
            <span className="leading-none">
              <span className="block font-heading text-xl md:text-2xl font-black tracking-wide text-foreground-950">
                抓奸实录
              </span>
              <span className="block mt-1 text-[10px] md:text-[11px] tracking-[0.24em] text-primary-700">
                网友热议 · 神评论聚集地
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.key}
                href={`#${l.key}`}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <div className="hidden md:flex items-center gap-2 rounded-full bg-background-100 border border-background-300/70 px-3 py-2 w-56">
              <i className="ri-search-line text-foreground-500 text-sm" />
              <input
                className="w-full bg-transparent outline-none text-sm placeholder:text-foreground-400"
                placeholder="搜现场 / 神评论 / 热议话题"
              />
            </div>
            <button className="hidden sm:inline-flex items-center gap-2 rounded-md bg-primary-600 hover:bg-primary-700 text-background-50 px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap">
              <i className="ri-group-line" />
              围观广场
            </button>
            <button
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden grid h-10 w-10 place-items-center rounded-md bg-background-100 border border-background-200"
              aria-label="菜单"
            >
              <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
            </button>
          </div>
        </div>

        {/* 分类细导航 */}
        <div className="hidden lg:block border-t border-background-200/70">
          <div className="mx-auto max-w-7xl px-6 h-11 flex items-center gap-2 overflow-hidden">
            <span className="inline-flex items-center gap-1 text-[11px] tracking-[0.2em] text-primary-700 shrink-0">
              <i className="ri-price-tag-3-line" /> 现场分区
            </span>
            <div className="flex items-center gap-1 flex-wrap">
              {ZONE_LINKS.map((z) => (
                <a
                  key={z.name}
                  href="#scene"
                  className="px-2.5 py-1 text-xs text-foreground-600 hover:text-primary-700 whitespace-nowrap"
                >
                  {z.name}
                </a>
              ))}
            </div>
            <a href="#faq" className="ml-auto text-xs text-accent-700 inline-flex items-center gap-1 whitespace-nowrap">
              围观须知 <i className="ri-arrow-right-s-line" />
            </a>
          </div>
        </div>
      </div>

      {/* 移动菜单 */}
      {open && (
        <div className="lg:hidden border-b border-foreground-950/10 bg-background-50">
          <nav className="mx-auto max-w-7xl px-4 py-3 grid grid-cols-2 gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.key}
                href={`#${l.key}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-700 rounded-md hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}